import { jobTypeList } from "constants/jobType";


const initialState = {
  jobTypeList: {},
};

const jobType = (state = initialState, action) => {
  switch (action.type) {
    case jobTypeList:
      return { ...state, jobTypeList: action.payload };
    default:
      return state;
  }
};

export default jobType;
